import { useState, useCallback } from 'react';
import { getSampleFilename, getPatternPreview } from '../utils/uploadHelpers';

/**
 * Hook for managing pattern extraction functionality
 */
export function usePatternExtraction() {
  const [extractionPattern, setExtractionPattern] = useState('');
  
  // Insert field placeholder into pattern
  const insertFieldPlaceholder = useCallback((fieldName) => {
    const placeholder = `{${fieldName}}`;
    setExtractionPattern(prev => {
      const separator = prev.endsWith('-') || prev.endsWith('_') ? '' : '_';
      return prev + separator + placeholder;
    });
  }, []);
  
  // Apply a template pattern
  const applyTemplate = useCallback((template) => {
    setExtractionPattern(template.pattern);
  }, []);
  
  // Clear pattern
  const clearPattern = useCallback(() => {
    setExtractionPattern('');
  }, []);
  
  // Get sample filename for preview
  const getSampleFilenameForPattern = useCallback((uploadedFiles) => {
    return getSampleFilename(uploadedFiles);
  }, []);
  
  // Get pattern preview results
  const getPatternPreviewForExtraction = useCallback((uploadedFiles, pattern = null) => {
    return getPatternPreview(uploadedFiles, pattern || extractionPattern);
  }, [extractionPattern]);
  
  return {
    // State
    extractionPattern,
    setExtractionPattern,
    
    // Methods
    insertFieldPlaceholder,
    applyTemplate,
    clearPattern,
    getSampleFilenameForPattern,
    getPatternPreviewForExtraction
  };
}